<template>
    <div>
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>

        <v-row v-if="componenteEvento.agregar_submodulo">
            <v-col class="d-flex justify-end">
                <ButtonComp @click="ViewCalendar()" textButton="Ver calendario" iconBut="fas fa-calendar"
                    normalButton />
            </v-col>
            <v-col cols="12">
                <ComundataTablecomp :headers="MisevaluacionesAlumHeaders" :items="data" whitSearch :search="search">
                    <template v-slot>
                        <v-row>
                            <v-col cols="12" md="6">
                                <AutocompleteComp textLabel="Área" v-model="filter.id_area"
                                    @change="eventArea(filter.id_grado, filter.id_area)" :items="listArea"
                                    item-value="id" item-text="desc_area" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <AutocompleteComp textLabel="Curso" v-model="filter.id_curso"
                                    @change="getEvaluacionAlumno(filter)" :items="listCurso" item-value="id"
                                    item-text="desc_curso" />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:fecha="{ item }">
                        {{ item.fecha | filtroFecha }}
                    </template>

                    <template v-slot:action_hora="{ item }">
                        {{ item.hora_inicio | filtroFormatoHora }} - {{ item.hora_fin | filtroFormatoHora }}
                    </template>

                    <template v-slot:id_estado_evaluacion="{ item }">
                        <v-chip small dark class="font-weight-black" :color="item.color_estado">
                            {{ item.estado_evaluacion }}
                        </v-chip>

                    </template>

                    <template v-slot:action_evaluar="{ item }">

                        <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                                <v-btn v-if="componenteEvento.editar_submodulo"
                                    :disabled="item.id_estado_evaluacion != 1 || validaInicioEval(item.fecha, item.hora_inicio)"
                                    @click="evaluarItem(item)" class="btn_agregar px-0 mx-0" fab x-small>
                                    <v-icon>fas fa-list-alt</v-icon>
                                </v-btn>
                            </template>
                            <span>APLICAR EVALUACIÓN {{ item.id_estado_evaluacion }} </span>
                        </v-tooltip>
                    </template>

                    <template v-slot:action_ver="{ item }">
                        <ButtonComp v-if="componenteEvento.editar_submodulo" :disabled="item.id_estado_evaluacion != 5"
                            @click="verItem(item)" verButton tooltipText="Ver evaluación" />
                    </template>


                    <template v-slot:action_nota="{ item }">
                        <v-chip
                            v-if="item.tipo_calificacion == 'L' && (item.id_estado_evaluacion == 5 || item.id_estado_evaluacion == 4)"
                            id_estado_evaluacion color="green" class="texto_white" label>{{ item.literal
                            }}</v-chip>
                        <v-chip v-else-if="item.tipo_calificacion == 'N' && item.id_estado_evaluacion == 5"
                            color="green" class="texto_white" label>{{ item.nota_alumno }} {{
            item.tipo_calificacion }}</v-chip>
                        <v-chip v-else color="green" class="texto_white" label> - </v-chip>

                    </template>
                </ComundataTablecomp>
            </v-col>
        </v-row>
        <!-- END de modal para visualizar Imagen-->
        <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @reloadComp="reloadComp"
            @close="closeComp">
        </component>

    </div>
</template>

<script>

import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';
import VisorEvaluacionComp from '@/views/Evaluacion/VisorEvaluacion/visorEvaluacion'
import CalendarioAlumnoComp from '@/views/Evaluacion/Calendario/CalendarioAlumno'
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue';
import AutocompleteComp from "../../../components/ComponentsEst/AutocompleteComp.vue";
import { MisevaluacionesAlumHeaders } from "../../../helpers/headersTable";
import io from 'socket.io-client';

export default {
    name: 'AlumnoEvaluacion',

    components: {
        VisorEvaluacionComp,
        CalendarioAlumnoComp,
        ButtonComp,
        ComundataTablecomp,
        AutocompleteComp
    },
    data: () => ({
        rutaservidor: API_URL,
        paramComponente: { "id_modulo": 7, 'id_submodulo': 97 },
        datoLogin: sessionStorage, // variables de sesion del usuario
        test: false,
        // componente General
        compName: null,
        estadoComponente: true,
        parametroComp: {},
        MisevaluacionesAlumHeaders,
        ////////////////////////////////////////////////////////
        // evento: 'agregar',
        search: '',
        data: [],
        filter: {},
        listAlumno: {},
        listArea: [],
        listCurso: [],
    }),
    computed: {
        ...mapGetters('login', ['componenteEvento'])
    },
    mounted() {
        this.loadMain();
        this.socket = io(API_URL);
        this.socket.on('evalActualizado', () => {
            this.loadMain();
        });
    },
    beforeDestroy() {
        this.socket.off('evalActualizado');
        this.socket.disconnect();
    },
    created() {
        this.actualizarParamentro();
    },
    methods: {
        ...mapActions('login', ['parametroComponente']),
        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },
        ...mapMutations('mensajeSis', ['setEnviarMens']),

        /** 
         _________________________________________
        |          MÉTODO CARGA INICIAL         */
        async loadMain() {
            this.limpiarForm()
            await this.getUserAlumno(this.datoLogin.id);
            this.getEvaluacionAlumno(this.filter);
        },
        /** 
         ________________________________________________________________________
        |          MÉTODO VALIDAR LA HORA DE INICIO DE LA EVALUACIÓN           */
        validaInicioEval(fecha, inicio) {
            let selectedDate = new Date(fecha).toISOString().substr(0, 10);
            const today = new Date();
            const formatter = new Intl.DateTimeFormat('es-PE', {
                timeZone: 'America/Lima',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
            const [{ value: day }, , { value: month }, , { value: year }] = formatter.formatToParts(today);
            const localDateInPeru = `${year}-${month}-${day}`;

            if (selectedDate == localDateInPeru) {
                const horaActualStr = [today.getHours(), today.getMinutes(), today.getSeconds()].map(num => num.toString().padStart(2, '0')).join(':');
                const horaEspecifica = inicio;
                if (horaActualStr >= horaEspecifica) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true
            }
        },
        /** 
         _______________________________________________________
        |          MÉTODO OBTENER EVALUACION ALUMNOS          */
        async getEvaluacionAlumno(filter) {
            try {

                let response = await axios.post(`/evaluacion/alumnos/view/`, { filter })

                this.data = response.data
                // .filter(ev => ev.id_estado_evaluacion != 1);

                if (this.data.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `No se encontrarón registros`, tiempo: null })
                }

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        /** 
         ___________________________________________________
        |          MÉTODO OBTENER ALUMNO USUARIO          */
        async getUserAlumno(id_usuario) {

            let params = { id_usuario, id_ano_lectivo: this.datoLogin.id_ano_lectivo }

            try {
                let response = await axios.post(`/sistema/integral/getAlumnoAnoLectivo/`, { filter: params })
                let resp = response.data

                if (resp.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `El usuario no es un estudiante`, tiempo: null })

                } else {
                    this.listAlumno = resp
                    this.filter.id_alumno = resp.id_alumno
                    this.filter.id_nivel = resp.id_nivel
                    this.filter.id_grado = resp.id_grado
                    this.filter.id_seccion = resp.id_seccion


                    this.getArea(this.filter.id_colegio, this.filter.id_grado)
                }

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
        /** 
         __________________________________________
        |          MÉTODO OBTENER AREAS          */
        async getArea(id_colegio, id_grado) {
            let params = { id_colegio, id_grado }

            try {
                let response = await axios.post(`/sistema/integral/getAreaAdm/`, { filter: params })
                this.listArea = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
        /** 
         ____________________________________________
        |          MÉTODO OBTENER CURSOS           */
        async getCurso(id_colegio, id_grado, id_area) {
            let params = { id_colegio, id_grado, id_area }
            try {

                let response = await axios.post(`/sistema/integral/getCurso/`, { filter: params })
                this.listCurso = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
        /** 
         ___________________________________________
        |          MÉTODO CAMBIAR AREA            */
        eventArea(id_grado, id_area) {
            this.filter.id_curso = ''
            this.getCurso(this.datoLogin.id_colegio, id_grado, id_area)
            this.getEvaluacionAlumno(this.filter)
        },
        /** 
         ________________________________________________
        |          MÉTODO OBTENER RESTAR HORAS         */
        restarHoras(horaInicio, horaFin) {
            let [h1, m1, s1] = horaInicio.split(':').map(num => parseInt(num, 10));
            let [h2, m2, s2] = horaFin.split(':').map(num => parseInt(num, 10));
            let totalSegundosInicio = h1 * 3600 + m1 * 60 + s1;
            let totalSegundosFin = h2 * 3600 + m2 * 60 + s2;
            let diferencia = totalSegundosInicio - totalSegundosFin;
            let h = Math.floor(diferencia / 3600).toString().padStart(2, '0');
            let m = Math.floor((diferencia % 3600) / 60).toString().padStart(2, '0');
            let s = (diferencia % 60).toString().padStart(2, '0');
            return `${h}:${m}:${s}`;
        },
        /** 
         ___________________________________________________
        |          MÉTODO ABRIR VISOR EVALUACION          */
        evaluarItem(items) {

            let resultado = this.transformToTime(items.duracion_evaluacion);
            if (items.fec_us_mod) {
                const fechaFin = new Date(Date.now()).toISOString();
                const fechaInicio_diferencia = new Date(items.fec_us_mod)
                const fechaFin_diferencia = new Date(fechaFin);
                const diferenciaEnMilisegundos = fechaFin_diferencia - fechaInicio_diferencia;
                const segundos = Math.floor(diferenciaEnMilisegundos / 1000);
                const minutos = Math.floor(segundos / 60);
                const horas = Math.floor(minutos / 60);
                const segundosRestantes = segundos % 60;
                const minutosRestantes = minutos % 60;
                const tiempoUsado = `${horas.toString().padStart(2, '0')}:${minutosRestantes.toString().padStart(2, '0')}:${segundosRestantes.toString().padStart(2, '0')}`;          

                if (tiempoUsado > resultado) {
                    resultado = null;
                    this.setEnviarMens({ tipo: "W", mensaje: `Se agotó el tiempo para realizar el examen`, tiempo: null })

                    return false;
                } else {
                    resultado = this.restarHoras(resultado, tiempoUsado);
                }
            }

            let params = {
                programaciones:items.id_programacion, //esto se manda en el caso quieras listar los temas y unidades incluidas en la evaluacion.
                id: items.id,
                id_evaluacion: items.id_evaluacion,
                id_colegio: items.id_colegio,
                id_profesor: items.id_profesor,
                id_alumno: items.id_alumno,
                duracion_evaluacion: items.duracion_evaluacion,
                fecha_modificada: items.fec_us_mod,
                tiempo_en_uso: resultado
            }

            let data = { evento: "evaluate", items: params }

            this.parametroComp = data
            this.compName = "VisorEvaluacionComp"
            this.estadoComponente = true

        },
        /** 
         _____________________________________________________________________
        |          MÉTODO TRANSFORMAR MINUTOS STRING A MINUTOS TIME         */
        transformToTime(input) {
            // Asegurarse de que el input sea un número
            let minutes = parseInt(input, 10);
            if (isNaN(minutes)) {
                throw new Error("Input must be a valid number");
            }

            // Calcular horas, minutos y segundos
            let hours = Math.floor(minutes / 60);
            let remainingMinutes = minutes % 60;
            let seconds = 0;

            // Formatear como "HH:MM:SS"
            let formattedTime =
                String(hours).padStart(2, '0') + ':' +
                String(remainingMinutes).padStart(2, '0') + ':' +
                String(seconds).padStart(2, '0');

            return formattedTime;
        },
        /** 
         _____________________________________________________________
        |          MÉTODO VER COMPONENTE CALIFICAR ALUMNOS          */
        verItem(items) {

            let params = {
                id_evaluacion: items.id_evaluacion,
                id_colegio: items.id_colegio,
                id_profesor: items.id_profesor,
                id_alumno: items.id_alumno,
                duracion_evaluacion: items.duracion_evaluacion
            }

            // qualifyAlumno
            let data = { evento: "qualifyAlumno", items: params }
            this.parametroComp = data
            this.compName = "VisorEvaluacionComp"
            this.estadoComponente = true

        },
        /** 
         _________________________________________________________
        |          MÉTODO ABRIR COMPOENENTE CALENDARIO          */
        ViewCalendar() {
            this.parametroComp = {
                evento: "add", id_alumno: this.filter.id_alumno,
                id_colegio: this.datoLogin.id_colegio, id_ano_lectivo: this.datoLogin.id_ano_lectivo
            }
            this.compName = "CalendarioAlumnoComp"
            this.estadoComponente = true
        },
        /** 
         ______________________________________________
        |          MÉTODO CERRAR COMPONENTE          */
        closeComp() {
            this.estadoComponente = false
            this.parametroComp = {}
            this.loadMain()
        },
        /** 
         ________________________________________________
        |          MÉTODO RECARGAR COMPONENTE          */
        reloadComp() {
        },
        /** 
         __________________________________________________________
        |          MÉTODO LIMPIAR FORMULARIO COMPONENTE          */
        limpiarForm() {

            this.filter = {
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_alumno: '',
                id_area: '',
                id_curso: '',
                id_seccion: ''
            }

            this.paramComponente = {}
            this.estadoComp = false
        },
    },
}
</script>
<style scoped>
.texto_white {
    font-size: 14px;
    font-weight: bold;
    color: #fff !important;

}
</style>